import { IPermissionUpdate, PermissionUpdateType } from './PermissionUpdateTypes'
import { DriverBreakPermissionSet, DutyPermissionSet, RequestPermissionSet, RiderUserPermissionSet } from './sets'

/**
 * List of permission updates.
 *
 * Each update must follow this format:
 * - key: YYYYMMDD-description-in-kebab-case
 * - description: Human-readable description of what the update does
 * - type: Currently only supports PermissionUpdateType.Grant
 * - update: Contains rolesWith (existing permission) and grant (new permissions to grant)
 *
 * Example:
 * ```typescript
 * {
 *   key: '20240130-grant-delete-to-editors',
 *   description: 'Grant delete permission on duties to groups with edit permission',
 *   type: PermissionUpdateType.Grant,
 *   update: {
 *     rolesWith: DutyPermissionSet.Edit,
 *     grant: [DutyPermissionSet.Delete],
 *   }
 * }
 * ```
 *
 * Updates are executed in order and tracked to prevent re-execution.
 */
export const getPermissionUpdates = (): IPermissionUpdate[] => [
  {
    key: '20250610-grant-driver-break-view',
    description: 'Grant driver break view permission',
    type: PermissionUpdateType.Grant,
    update: { rolesWith: DutyPermissionSet.View, grant: [DriverBreakPermissionSet.View] },
  },
  {
    key: '20250610-grant-driver-break-reason-view',
    description: 'Grant driver break reason view permission',
    type: PermissionUpdateType.Grant,
    update: { rolesWith: DutyPermissionSet.View, grant: [DriverBreakPermissionSet.ViewReason] },
  },
  {
    key: '20250610-grant-driver-break-write',
    description: 'Grant driver break write permission',
    type: PermissionUpdateType.Grant,
    update: { rolesWith: DutyPermissionSet.Edit, grant: [DriverBreakPermissionSet.Write] },
  },
  {
    key: '20250610-grant-driver-break-reason-write',
    description: 'Grant driver break reason write permission',
    type: PermissionUpdateType.Grant,
    update: { rolesWith: DutyPermissionSet.Edit, grant: [DriverBreakPermissionSet.WriteReason] },
  },
  {
    key: '20250610-grant-driver-break-reason-delete',
    description: 'Grant driver break reason delete permission',
    type: PermissionUpdateType.Grant,
    update: { rolesWith: DutyPermissionSet.Edit, grant: [DriverBreakPermissionSet.DeleteReason] },
  },
  {
    key: '20250709-grant-rider-archive',
    description: 'Grant rider archive permission',
    type: PermissionUpdateType.Grant,
    update: { rolesWith: RiderUserPermissionSet.Edit, grant: [RiderUserPermissionSet.Archive] },
  },
  {
    key: '20250724-grant-lock-to-duty',
    description: 'Grant lock to duty permission to roles with request write permission',
    type: PermissionUpdateType.Grant,
    update: { rolesWith: RequestPermissionSet.Write, grant: [RequestPermissionSet.LockToDuty] },
  },
  // Add permission updates here
]
